// @/plugins/2.pinia/modules/nfts/types/nftTypes.js

// NFT Type Constants
export const NFT_TYPES = {
  PILOT: 'pilot',
  MECH: 'mech',
  ORB: 'orb',
  EQUIPMENT: 'equipment',
  SPARKLE: 'sparkle',
};

// Helper function to normalize NFT type
export const normalizeNftType = (nft) => {
  // Convert nftType to standardized format
  const nftType = nft.nftType ? nft.nftType.toLowerCase() : '';
  
  // If no nftType is provided, default to pilot
  if (!nftType) {
    return NFT_TYPES.PILOT;
  }
  
  // Map the types according to your business logic
  if (nftType === 'mystic') {
    return NFT_TYPES.PILOT;
  } else if (nftType === 'hero') {
    return NFT_TYPES.PILOT; 
  } else if (nftType === 'mech') {
    return NFT_TYPES.MECH;
  } else if (nftType === 'orb') {
    return NFT_TYPES.ORB;
  } else if (nftType === 'equipment') {
    return NFT_TYPES.EQUIPMENT;
  } else if (nftType === 'sparkle') {
    return NFT_TYPES.SPARKLE;
  }
  
  // If we have an unknown type, default to pilot instead of returning the unknown type
  return NFT_TYPES.PILOT;
};

// Helper function to capitalize first letter for display purposes
export const capitalize = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Format an NFT object into a standard structure
export const formatNft = (nft) => {
  const type = normalizeNftType(nft);
  const metadata = nft.metadata || {};
  const displayType = capitalize(type);
  
  return {
    ...nft, // Copy all fields from the original object
    // Then override or add specific fields we need with safe access
    name: metadata.name || `Unknown ${displayType}`,
    type: displayType, // Normalized type for our app usage
    image_url: metadata.image_url || '',
    token_id: nft.token_id ?? "",
    token_address: nft.token_address || "", 
    level: metadata.level || '0',
    mystic: metadata.mystic || '',
    second_mystic: metadata.second_mystic || '',
    effect: metadata.effect || "",
    description: metadata.description || '',
    is_anoint: metadata.is_anoint || false,
    nftType: nft.nftType || type.toLowerCase(), 
    attributes: metadata.attributes || []
  };
};

// Checking if an NFT is staked based on its ID format or flag
export const isNftStaked = (nft) => {
  if (!nft) return false;
  
  return nft.isStaked === true || 
         (nft.id && typeof nft.id === 'string' && nft.id.includes('staked-'));
};
